import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getNearestNodeFromDOMNode } from 'lexical';
import { $isToggleNode } from '../nodes/ToggleNode';

export default function TogglePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target;

      // Only respond to clicks on the toggle-block element itself (arrow area)
      if (!target.classList.contains('toggle-block')) return;

      const rect = target.getBoundingClientRect();
      const clickX = event.clientX - rect.left;

      // Click must be in the arrow area (first 24px)
      if (clickX > 24) return;

      event.preventDefault();
      event.stopPropagation();

      editor.update(() => {
        const node = $getNearestNodeFromDOMNode(target);
        if ($isToggleNode(node)) {
          node.setOpen(!node.getOpen());
        }
      });
    };

    const editorElement = editor.getRootElement();
    if (editorElement) {
      editorElement.addEventListener('click', handleClick);
    }

    return () => {
      if (editorElement) {
        editorElement.removeEventListener('click', handleClick);
      }
    };
  }, [editor]);

  return null;
}
